import Vue from "vue";
import VueRouter from "vue-router";

import Home from "../pages/indices/Home.vue";
import SignupPageOne from "../pages/auth/SignupPageOne.vue";
import SignupPageTwo from "../pages/auth/SignupPageTwo.vue";
import Page404 from "../pages/utilities/Page404.vue";
import ComingsoonPage from "../pages/utilities/ComingsoonPage.vue";
import ThankyouPage from "../pages/ThankyouPage.vue";
import Join from "../pages/joinPage.vue";
import about from "../pages/aboutPage.vue";
import meeting from "../pages/meetingPage.vue";
import services from "../pages/servicesPage.vue";
import contact from "../pages/contactPage.vue";
import Matching from "../pages/matchingPage.vue";
import Confinementservice from "../pages/ConfinementservicePage.vue";
import relatedVideo from "../pages/relatedVideo.vue";
import allianceMatching from "../views/allianceMatching.vue";
import recipes from "../pages/recipesPage.vue";
import privacy from "../pages/privacyPage.vue";
import terms from "../pages/termsPage.vue";
Vue.use(VueRouter);

const routes = [
	{
		path: "/",
		name: "Home",
		component: Home,
		meta: {
			title: "Hong Kong Maid & Helper Agency 香港家政服務中心｜菲傭・印傭・外傭僱傭中心",
			description:
				"Hong Kong maid & domestic helper agency 香港僱傭中心。Hire trusted Filipino and Indonesian helpers (菲傭、印傭) for housework, childcare and elderly care. Licensed HK employment centre, full visa & contract handling.",
		},
	},
	{
		path: "/about",
		name: "about",
		component: about,
		meta: {
			title: "About Us 關於我們｜HK Home Services 香港家政服務中心",
			description:
				"Licensed Hong Kong employment agency for foreign domestic helpers. 持牌香港僱傭中心，專業菲傭印傭配對，誠信可靠。",
		},
	},
	{
		path: "/services",
		name: "services",
		component: services,
		meta: {
			title: "Our Services 服務範圍｜Maid Placement, Visa & Contract 外傭配對僱傭手續",
			description:
				"Domestic helper recruitment, matching, visa and contract processing in Hong Kong. 外傭招聘配對、簽證及合約手續、陪月及家務助理服務。",
		},
	},
	{
		path: "/contact",
		name: "contact",
		component: contact,
		meta: {
			title: "Contact Us 聯絡我們｜HK Home Services 香港家政服務中心",
			description:
				"Contact our Hong Kong maid agency: +852 2559 9223, Whampoa 108, Hung Hom. 聯絡香港家政服務中心，紅磡黃埔108商場18號舖。",
		},
	},
	{
		path: "/signup-1",
		name: "signup-1",
		component: SignupPageOne,
	},
	{
		path: "/signup-2",
		name: "signup-2",
		component: SignupPageTwo,
	},
	{
		path: "/404",
		name: "404",
		component: Page404,
	},
	{
		path: "/coming-soon",
		name: "coming-soon",
		component: ComingsoonPage,
	},
	{
		path: "/thank-you",
		name: "thank-you",
		component: ThankyouPage,
	},
	{
		path: "/join",
		name: "join",
		component: Join,
	},
	{
		path: "/matching",
		name: "matching",
		component: Matching,
		meta: {
			title: "Find a Helper 外傭配對｜Filipino & Indonesian Maids Available in Hong Kong",
			description:
				"Browse and match with Filipino and Indonesian domestic helpers available now in Hong Kong. 即時配對現成及海外菲傭印傭。",
		},
	},
	{
		path: "/confinementservice",
		name: "confinementservice",
		component: Confinementservice,
		meta: {
			title: "Confinement Care 陪月服務｜HK Home Services 香港家政服務中心",
			description: "Professional confinement care services in Hong Kong. 專業陪月服務，照顧產後媽媽及初生嬰兒。",
		},
	},
	{
		path: "/relatedVideo",
		name: "relatedVideo",
		component: relatedVideo,
	},

	{
		path: "/meeting/:id",
		name: "meeting",
		component: meeting,
	},
	{
		path: "/allianceMatching",
		name: "allianceMatching",
		component: allianceMatching,
	},
	{
		path: "/recipes",
		name: "recipes",
		component: recipes,
	},
	{
		path: "/privacy",
		name: "privacy",
		component: privacy,
	},
	{
		path: "/terms",
		name: "terms",
		component: terms,
	},
];

const router = new VueRouter({
	mode: "history",
	base: process.env.BASE_URL,
	routes,
	scrollBehavior(to, from, savedPosition) {
		if (to.hash) {
			const element = document.getElementById(to.meta.anchor);
			if (element) {
				return window.scrollTo({
					top: element.offsetTop,
					behavior: "smooth",
				});
			}
		} else if (savedPosition) {
			return savedPosition;
		} else {
			return { x: 0, y: 0 };
		}
	},
});

const DEFAULT_TITLE = "Hong Kong Maid & Helper Agency 香港家政服務中心｜菲傭・印傭・外傭僱傭中心";
const SITE_ORIGIN = "https://hkhomeservices.com.hk";

function setMetaTag(attr, name, content) {
	let el = document.head.querySelector(`meta[${attr}="${name}"]`);
	if (!el) {
		el = document.createElement("meta");
		el.setAttribute(attr, name);
		document.head.appendChild(el);
	}
	el.setAttribute("content", content);
}

router.beforeEach((to, from, next) => {
	document.title = (to.meta && to.meta.title) || DEFAULT_TITLE;
	if (to.meta && to.meta.description) {
		setMetaTag("name", "description", to.meta.description);
		setMetaTag("property", "og:description", to.meta.description);
	}
	setMetaTag("property", "og:title", document.title);
	const canonicalUrl = SITE_ORIGIN + (to.path === "/" ? "/" : to.path);
	let canonical = document.head.querySelector('link[rel="canonical"]');
	if (!canonical) {
		canonical = document.createElement("link");
		canonical.setAttribute("rel", "canonical");
		document.head.appendChild(canonical);
	}
	canonical.setAttribute("href", canonicalUrl);
	setMetaTag("property", "og:url", canonicalUrl);
	next();
});

export default router;
